import styled, { css, keyframes } from 'styled-components';
import { palette } from '../../../palette';
import { px } from '../../../utils';
import { createShouldForwardProp } from '../../utils';
export const LoaderIconRoot = styled.svg.withConfig({
  shouldForwardProp: createShouldForwardProp(['size'])
}).withConfig({
  componentId: "ds__sc-1lsj16o-0"
})(["display:inline-block;flex-shrink:0;", " transform:rotate(-90deg);transform-origin:center;"], _ref => {
  let {
    size
  } = _ref;
  return size !== undefined && css(["width:", ";height:", ";"], px(size), px(size));
});
export const Ring = styled.circle.attrs(() => ({
  opacity: 0.1,
  cx: 50,
  cy: 50,
  r: 20
})).withConfig({
  componentId: "ds__sc-1lsj16o-1"
})(["stroke-width:3px;fill:", ";stroke:", ";"], _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.Loader.fillColor;
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.Loader.strokeColor;
});
const dashAnimation = keyframes(["0%{stroke-dasharray:2,200;stroke-dashoffset:0;}85%{stroke-dasharray:200,200;stroke-dashoffset:-124px;}100%{stroke-dasharray:200,200;stroke-dashoffset:-124px;}"]);
const createLoaderAnimation = _ref4 => {
  let {
    animationColors
  } = _ref4;
  return keyframes(["100%,0%,15%{stroke:", ";}16%,31%{stroke:", ";}32%,47%{stroke:", ";}48%,63%{stroke:", ";}64%,79%{stroke:", ";}80%,95%{stroke:", ";}"], animationColors.stepColor1, animationColors.stepColor2, animationColors.stepColor3, animationColors.stepColor4, animationColors.stepColor5, animationColors.stepColor6);
};
export const AnimatedRingFill = styled.circle.attrs(() => ({
  fill: 'none',
  cx: 50,
  cy: 50,
  r: 20
})).withConfig({
  componentId: "ds__sc-1lsj16o-2"
})(["stroke-width:3px;transform-origin:center center;animation-name:", ";animation-duration:1s,6s;animation-timing-function:ease-in,ease;animation-iteration-count:infinite,infinite;stroke:", ";stroke-dasharray:2,200;stroke-dashoffset:0;stroke-linecap:round;@media screen and (prefers-reduced-motion:reduce),(update:slow){animation-iteration-count:infinite,infinite !important;}"], _ref5 => {
  let {
    theme
  } = _ref5;
  return css(["", ",", ""], dashAnimation, createLoaderAnimation(theme.Loader));
}, palette.red30);